import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';
import Icon from 'components/Icon';
import { Colors } from 'modules/theme';

const IconAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  cursor: help;
  line-height: 1;
`;

let counter = 0;
const nextId = () => {
  counter += 1;
  return `info-tooltip-${counter}`;
};

export default class InfoTooltip extends React.PureComponent {
  constructor(props) {
    super(props);
    this.id = nextId();
  }

  render() {
    const { content, place, fontSize } = this.props;
    return (
      <>
        <IconAnchor data-tooltip-id={this.id} data-tooltip-content={content}>
          <Icon name="info-circle" color={Colors.gray8} fontSize={fontSize} />
        </IconAnchor>
        <Tooltip id={this.id} place={place} style={{ maxWidth: 280, zIndex: 9999 }} />
      </>
    );
  }
}

InfoTooltip.propTypes = {
  content: PropTypes.string.isRequired,
  fontSize: PropTypes.number,
  place: PropTypes.string,
};

InfoTooltip.defaultProps = {
  fontSize: 13,
  place: 'top',
};
